import { render } from "./LoadingScreen.vue?vue&type=template&id=ca2c0990&scoped=true"
import script from "./LoadingScreen.vue?vue&type=script&lang=js"
export * from "./LoadingScreen.vue?vue&type=script&lang=js"

import "./LoadingScreen.vue?vue&type=style&index=0&id=ca2c0990&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Setrin\\dev\\NTS\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca2c0990"]])

export default __exports__